























import Vue from 'vue';
import DvPopover from './DvPopover.vue';

export default Vue.extend({
    name: 'DvFilterPopover',
    components: { DvPopover },
    props: {
        label: { type: String, required: true },
        activeCount: { type: Number, default: 0 },
        searchable: { type: Boolean, default: false },
        note: { type: String, default: '' },
    },
    data() {
        return { open: false, term: '', triggerEl: null as HTMLElement | null };
    },
    mounted() {
        this.triggerEl = this.$refs.trigger as HTMLElement;
    },
    watch: {
        //  DvPopover's <portal v-if="open"> fully destroys and recreates the
        //  panel DOM on every close/reopen -- a stale term would leave the
        //  search input and the freshly-mounted, unfiltered <li>s disagreeing.
        //  Clearing on close keeps a reopened panel always starting unfiltered.
        open(now: boolean) {
            if (!now) this.term = '';
        },
        //  Hide non-matching rows by text content. The slot owns the markup, so
        //  filtering is done on the rendered DOM rather than on a data list.
        //  `.panel-body` renders inside DvPopover's <portal>, so it is not a
        //  descendant of this.$el in the live DOM once mounted -- a ref (which
        //  Vue resolves against the owning component regardless of where the
        //  slot content is teleported to) is required to reach it, not a
        //  querySelector scoped to $el.
        term() {
            const body = this.$refs.body as HTMLElement | undefined;
            if (!body) return;
            const t = this.term.trim().toLowerCase();
            body.querySelectorAll('li').forEach((li) => {
                const hit = !t || (li.textContent ?? '').toLowerCase().includes(t);
                (li as HTMLElement).hidden = !hit;
            });
        },
    },
});
